import React from 'react';
import log from '@/lib/logger';
import { Button } from '@/shared/components/ui/button';
import { useRouter } from '@tanstack/react-router';

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, resetErrorBoundary }) => {
  const router = useRouter();
  log.error(error);
  // Call resetErrorBoundary() to reset the error boundary and retry the render.
  return (
    <div className="d-flex flex-column flex-grow align-items-center justify-content-center p-4">
      <h2>Ups! Tuvimos un problema</h2>
      <div className="d-flex">
        <Button variant="secondary" onClick={() => router.history.back()}>
          Ir atrás
        </Button>
        <Button onClick={resetErrorBoundary}>Reintentar</Button>
      </div>
    </div>
  );
};

export default ErrorFallback;
